import { v2 } from "./v2";
import { useVariant } from "./variant";
var variants = {
    v2: v2,
};
export function useQualifyzeTheme() {
    var additional = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        additional[_i] = arguments[_i];
    }
    return variants[useVariant()].apply(variants, additional);
}
